import { InjectionToken } from '@angular/core';
import { ICapturesService } from '../../interfaces/services/captures-service.interface';

export const CAPTURES_SERVICE = new InjectionToken<ICapturesService>('CapturesService');
